import { type SerializedError } from '@databases/types';

import { deserializeError } from '../utils';

export enum AsyncOperationStatus {
  INITIAL = 'initial',
  PENDING = 'pending',
  SUCCEEDED = 'succeeded',
  ERROR = 'error',
}

export type AsyncOperation<T> =
  | { status: AsyncOperationStatus.INITIAL | AsyncOperationStatus.PENDING }
  | (T extends void
      ? { status: AsyncOperationStatus.SUCCEEDED }
      : { status: AsyncOperationStatus.SUCCEEDED; data: T })
  | { status: AsyncOperationStatus.ERROR; error: SerializedError };

export function validateStatus(status: AsyncOperation<any> | undefined): void {
  if (status?.status === AsyncOperationStatus.ERROR) {
    throw deserializeError(status.error);
  }
}
